import { useFeatureFlagContext } from './FeatureFlagProvider';
import type { FeatureFlags } from '@tokenforge/shared';

export function useFeatureFlag<K extends keyof FeatureFlags>(key: K): FeatureFlags[K] {
  const { flags } = useFeatureFlagContext();
  return flags[key];
}
